// hooks/useIsMobile.ts
import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 600): boolean | null {
  const [isMobile, setIsMobile] = useState<null | boolean>(null);

  useEffect(() => {
    const query = `(max-width: ${breakpoint}px)`;
    const mediaQuery = window.matchMedia(query);
    setIsMobile(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}
